import React from "react"
import {
  DropdownDivider,
  DropdownMenuItem,
  DropdownSubheader,
} from "../Dropdown"

export default function TopicsDropdown({ close }) {
  const categories = misago.get("categoriesMap") || []
  const baseUrl = misago.get("MISAGO_PATH")

  return (
    <ul className="dropdown-menu-list topics-dropdown-menu">
      <DropdownSubheader>
        {pgettext("topics dropdown", "Browse Topics")}
      </DropdownSubheader>
      {categories.length === 0 ? (
        <DropdownMenuItem>
          <span style={{ color: "#6b7280", fontStyle: "italic" }}>
            {pgettext("topics dropdown", "No topics available")}
          </span>
        </DropdownMenuItem>
      ) : (
        categories.map((category) => (
          <DropdownMenuItem className="topics-dropdown-category" key={category.id}>
            <a 
              href={category.url}
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
            >
              <span>{category.name}</span>
              {category.color && (
                <span
                  className="category-color-indicator"
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: category.color,
                    marginLeft: "8px",
                    flexShrink: 0
                  }}
                />
              )}
            </a>
          </DropdownMenuItem>
        ))
      )}
    </ul>
  )
}